import sectionImg from "../../images/Sec 08 Horizontal.webp";
import styles from "./Section08FAQ.module.scss";

const heroImageSrc = sectionImg?.default || sectionImg;

const UserIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#071b52" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const ClipboardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#071b52" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    <path d="M9 10h6"></path>
    <path d="M9 14h6"></path>
    <path d="M9 18h6"></path>
  </svg>
);

const AccountantIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#071b52" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const ChartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#071b52" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"></line>
    <line x1="12" y1="20" x2="12" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="14"></line>
    <polyline points="2 17 9 10 14 15 22 4"></polyline>
  </svg>
);

const ShieldCheckIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#071b52" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <path d="M9 12l2 2 4-4"></path>
  </svg>
);

const ClockIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#071b52" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

export const ChevronDownIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#071b52" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

const faqs = [
  {
    icon: <UserIcon />,
    question: "Do I need accounting knowledge to use Munafa Engine?",
    answer:
      "No. Munafa Engine is designed to stay simple for salon owners. You or your team only need to share a few basic daily salon numbers. We then turn those numbers into a simple weekly view that is visual, easy to understand, and practical to use.",
  },
  {
    icon: <ClipboardIcon />,
    question: "Will this create extra work for me or my staff?",
    answer:
      "No. The process is designed to stay light and manageable. It works with simple daily salon numbers and does not require a complicated setup, new software, or heavy staff involvement.",
  },
  {
    icon: <AccountantIcon />,
    question: "Will this replace my CA or accountant?",
    answer:
      "No. Munafa Engine does not replace your CA or accountant. Their role is different. Munafa Engine focuses on weekly salon clarity — helping you understand profit position, leak areas, expense pressure, and what your numbers are showing week by week.",
  },
  {
    icon: <ChartIcon />,
    question: "What kind of clarity will I start seeing each week?",
    answer:
      "You start seeing your salon's weekly position more clearly — including where money came in, where it went out, what was left, where profit may be leaking, and what needs attention in the coming week.",
  },
  {
    icon: <ShieldCheckIcon />,
    question: "Is my salon data kept private and confidential?",
    answer:
      "Yes. Your salon data is handled with care, respect, and confidentiality. The purpose is to help you make better weekly decisions while keeping your information protected.",
  },
  {
    icon: <ClockIcon />,
    question: "How much time will I need to give from my side?",
    answer:
      "Only a small amount of regular input is needed from your side or from someone in your team. The process is designed to stay simple, so that weekly clarity improves without adding unnecessary pressure to your routine.",
  },
];

const Section08FAQ = () => {
  return (
    <section id="faq" className={`section ${styles.section08}`}>
      <div className={styles.inner}>
        <div className={styles.topRow}>
          <div className={styles.textContainer}>
            {/* <span className={styles.sectionLabel}>SECTION 08</span> */}
            <h2 className={styles.heading}>
              Questions salon owners <span className={styles.headingAccent}>usually ask</span>
            </h2>
            <p className={styles.subtext}>
              Simple answers to the Questions Salon Owners Usually Ask Before Getting Started.
            </p>
          </div>

          <div className={styles.imageWrapper}>
            <img
              src={heroImageSrc}
              alt="Salon owner FAQ illustration"
              className={styles.heroImage}
             loading="lazy" decoding="async"/>
          </div>
        </div>

        <div className={styles.faqGrid}>
          {faqs.map((item, index) => (
            <article className={styles.faqCard} key={item.question}>
              <div className={styles.cardTop}>
                <div className={styles.iconGroup}>
                  <div className={styles.iconCircle} aria-hidden="true">
                    {item.icon}
                  </div>
                  <div className={styles.numberBadge}>{index + 1}</div>
                </div>
                <div className={styles.questionWrapper}>
                  <h3 className={styles.question}>{item.question}</h3>
                  <span className={styles.chevron}>
                    <ChevronDownIcon />
                  </span>
                </div>
              </div>
              <p className={styles.answer}>{item.answer}</p>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Section08FAQ;

